export default __webpack_public_path__ + "static/media/z.a658d465.svg";